import { render } from "./AudioSeriesDrawerOverview.vue?vue&type=template&id=ba64c374&scoped=true"
import script from "./AudioSeriesDrawerOverview.vue?vue&type=script&lang=js"
export * from "./AudioSeriesDrawerOverview.vue?vue&type=script&lang=js"

import "./AudioSeriesDrawerOverview.vue?vue&type=style&index=0&id=ba64c374&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba64c374"]])

export default __exports__